import React from 'react';
import PropTypes from 'prop-types';
import {Message, Icon} from 'epic-diesel-common';
import {sizes, svgs} from 'epic-diesel-common/src/constants';
import styles from './Alert.pcss';

class Alert extends React.Component {
    static propTypes = {
        message: PropTypes.string,
        type: PropTypes.string,
        customClassNames: PropTypes.string,
        show: PropTypes.bool,
        closeable: PropTypes.bool,
        closeAlert: PropTypes.func,
        html: PropTypes.bool
    };

    render() {
        const {type, message, closeable, customClassNames, show, html} = this.props;

        const alertType = `alert${type}`;

        if (!show) {
            return <span />;
        }

        return (
            <div className={`${styles.alertContainer} ${customClassNames || ''}`}>
                <div className={`${styles.alert} ${styles[alertType]}`}>
                    <div className={styles.iconContainer}>
                        <i className={styles.alertInfoIcon} />
                    </div>
                    <div className={styles.alertContent}>
                        {/*eslint-disable react/no-danger*/}
                        {html ? (
                            <p dangerouslySetInnerHTML={{__html: message}} />
                        ) : (
                            <p>
                                {' '}
                                <Message code={message} />
                            </p>
                        )}
                    </div>
                    {closeable && (
                        <button
                            type="button"
                            className={styles.close}
                            onClick={this.props.closeAlert}
                            aria-label="Close">
                            <Icon icon={svgs.CLOSE} size={sizes.SMALL} />
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

export default Alert;
